"use client";

import { createContext, useContext } from "react";

// Lets a component (e.g. Form) know it is being rendered as a button's
// modal_body inside a Dialog, so it can adapt its layout (e.g. render its
// title/description as DialogTitle/DialogDescription instead of its own
// standalone heading).
const context = createContext(false);

export const ModalProvider = context.Provider;

export const useIsModal = () => useContext(context);
